//System
import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, ViewContainerRef, Compiler, Input, Inject } from '@angular/core';
import { Router, ActivatedRoute} from "@angular/router";
//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { AuthService } from './../../../../services/core/auth.service';
import { NewsletterService } from "./../../../../services/cms/newsletter.service";

//Models
import { UserLogin } from "./../../../../models/cms/user-login";
import { Company } from "./../../../../models/core/company";

import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../../services/cms/header.service';
import { LanguageService } from '../../../../services/cms/language.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector: "dy-footer",
    template: ''
})

export class FooterComponent implements OnInit {
    data: any = {};

    @Input() parentFooterData: any;

    constructor(
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private _elementRef: ViewContainerRef,
        private cmsComponentService: CmsComponentService,
        private route: ActivatedRoute,
        private router: Router,
        @Inject('isBrowser') private isBrowser: boolean

    ){this.router.routeReuseStrategy.shouldReuseRoute = () => false; }

        subManager = new Subscription();

    ngOnInit() {
        if(!this.isBrowser)
            return;

        if (this.parentFooterData != null) {
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(this.parentFooterData);
            //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }

        else {
            let footerData: any;

            let footerSub = this.cmsComponentService.getFooterData().subscribe(result => {
                footerData = result;
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(footerData);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            });

            this.subManager.add(footerSub);
        }
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    //Creates component to inject 
    private createSubComponent(footerData: any) {
        @Component({
            template: footerData.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                private routesService: RoutesService,
                private authService: AuthService,
                private languageService: LanguageService,
                private newsletterService: NewsletterService,
                private headerService: HeaderService
                ) {
                    this.headerService.getLoggedInUser().subscribe((user: UserLogin | null) => {
                        this.loggedIdUser = user;
                    });
                }

            private loggedIdUser: UserLogin = new UserLogin();
            private company: Company = footerData.Company;
            public isActiveQuickRegistration: boolean = footerData.IsActiveQuickRegistration;

            private faqPageName: string[] = this.routesService.getRoutePath('FAQ');
            private privacyPageName: string[] = this.routesService.getRoutePath('INFO PRIVACY');
            private cookiePageName: string[] = this.routesService.getRoutePath('INFO COOKIE');
            private purchasePageName: string[] = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
            private contactPageName: string[] = this.routesService.getRoutePath('RICHIESTA INFORMAZIONI');
            private loginPageName: string[] = this.routesService.getRoutePath('LOGIN');
            private passwordPageName: string[] = this.routesService.getRoutePath('RECUPERA PASSWORD');
            private registerPageName: string[] = this.routesService.getRoutePath('REGISTRAZIONE');
            private areaClientiPageName: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
            private carrelloPageName: string[] = this.routesService.getRoutePath('CARRELLO');
            private blogPageName: string[] = this.routesService.getRoutePath('BLOG');

            //Newsletter variables
            private newsletterSubmitted: boolean;
            private privacySubmitted: boolean;
            private alreadySubscribed: boolean;
            private successfullySubscribed: boolean;
            private isCaptchaInvalid = true;
            public verified: any;
            public siteKey: string = "6LcTlhYTAAAAAADnzMzRAmFtNPyHxr-IvkwXfCZ1";
            public theme: string = "light";
            public lang = this.languageService.getShortLang();

            public isArrayInit: boolean = false;
            private spinnerNewslatter: boolean = false;

            private model = {
                Email: ""
            };

            subManager = new Subscription();

            ngOnInit() {
                //setup of links, they must start with http to work properly
                let linkStart = "http://";
                let linkSecuredStart = "https://";

                if (this.company.Facebook != null) {
                    if (this.company.Facebook.indexOf(linkStart) == -1 && this.company.Facebook.indexOf(linkSecuredStart) == -1) {
                        this.company.Facebook = linkStart + this.company.Facebook;
                    }
                }

                if (this.company.Youtube != null) {
                    if (this.company.Youtube.indexOf(linkStart) == -1 && this.company.Youtube.indexOf(linkSecuredStart) == -1) {
                        this.company.Youtube = linkStart + this.company.Youtube;
                    }
                }

                if (this.company.Twitter != null) {
                    if (this.company.Twitter.indexOf(linkStart) == -1 && this.company.Twitter.indexOf(linkSecuredStart) == -1) {
                        this.company.Twitter = linkStart + this.company.Twitter;
                    }
                }

                if (this.company.Website != null) {
                    if (this.company.Website.indexOf(linkStart) == -1 && this.company.Website.indexOf(linkSecuredStart) == -1) {
                        this.company.Website = linkStart + this.company.Website;
                    }
                }

                if (this.company.Instagram != null) {
                    if (this.company.Instagram.indexOf(linkStart) == -1 && this.company.Instagram.indexOf(linkSecuredStart) == -1) {
                        this.company.Instagram = linkStart + this.company.Instagram;
                    }
                }
            }

            onSubmit(form) 
            {
                this.spinnerNewslatter = true;
                if (form) 
                {
                    let newsletterSub = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(result => 
                    {
                        if (result == "-1")
                        {
                            this.alreadySubscribed = true;
                            this.successfullySubscribed = false;
                            this.spinnerNewslatter = false;
                        }

                        else {
                            this.alreadySubscribed = false;
                            this.successfullySubscribed = true;
                            this.spinnerNewslatter = false;
                        }
                    });

                    this.subManager.add(newsletterSub);
                }

                else 
                {
                    this.spinnerNewslatter = false;                       
                }
            }

            setVerified(data) {
                this.isCaptchaInvalid = !data;
            }

            showModalQuickRegistrationEmail() {
                //-- We set z-index to 1041 because there is a element with z-index 1040 that overrides modal
                (document.querySelector('#header') as HTMLElement).style.zIndex = '1041';
                $(`#quickRegistrationEmailModal`).modal("show");
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/footer/widget/footer.component.ts